import React, { HTMLProps } from 'react';
import { css, cx } from '@linaria/atomic';

interface Props extends HTMLProps<HTMLAnchorElement> {
  children: React.ReactNode;
  trackingId?: string;
}

const nakedAStyles = css`
  color: currentColor;
  text-decoration: none;
`;

export const NakedA = ({ children, trackingId, className, ...rest }: Props) => (
  <a className={cx(nakedAStyles, className)} data-trackingid={trackingId} {...rest}>
    {children}
  </a>
);
